import React, { ComponentProps, forwardRef } from "react";
import { cn } from "../../Helpers";

const Flex = forwardRef<HTMLInputElement, ComponentProps<"div">>(
    ({ className, ...props }, ref) => (
        <div
            className={cn('flex', className)}
            ref={ref}
            {...props}
        />
    )
);

Flex.displayName = "Flex";

export { Flex };
